(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/quickplay-modal/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/components/sport/quickplay-modal/assets/javascripts/init.js');
"use strict";


const _svs$components$sport = svs.components.sport.quickplayModal,
  getModalRoot = _svs$components$sport.getModalRoot,
  QuickplayModal = _svs$components$sport.QuickplayModal;

function init(_ref) {
  let branding = _ref.branding,
    productId = _ref.productId,
    drawNumber = _ref.drawNumber,
    hasSaveButton = _ref.hasSaveButton,
    systemCost = _ref.systemCost,
    systemType = _ref.systemType,
    rowPrice = _ref.rowPrice,
    productSizes = _ref.productSizes,
    _ref$isPixMix = _ref.isPixMix,
    isPixMix = _ref$isPixMix === void 0 ? false : _ref$isPixMix,
    initiator = _ref.initiator;
  const app = React.createElement(QuickplayModal, {
    branding: branding,
    drawNumber: parseInt(drawNumber, 10),
    hasSaveButton: hasSaveButton,
    initiator: initiator,
    isPixMix: isPixMix,
    productId: parseInt(productId, 10),
    productSizes: productSizes,
    rowPrice: parseFloat(rowPrice),
    systemCost: parseFloat(systemCost),
    systemType: systemType
  });
  const root = getModalRoot({
    unmount: true
  });
  ReactDOM.render(app, root);
}
setGlobal('svs.components.sport.quickplayModal.init', init);

 })(window);